import React from 'react'
import { Snackbar } from '@material-ui/core'

export default class Snack extends React.Component {
	static instance = null

	constructor() {
		super()
		Snack.instance = this

		this.state = {
			text: 'error',
			type: 'error',
			open: false
		}
	}

	show(text, type) {
		if (type === 'error') {
			console.error(text)
		}

		this.setState({
			text: (text ?? 'Unknown').toString(),
			type: type ?? 'info',
			open: true
		})
	}

	hide() {
		this.setState({
			open: false
		})
	}

	render() {
		return (
			<Snackbar
				elevation={6}
				severity={this.state.type}
				open={this.state.open}
				autoHideDuration={3000}
				message={this.state.text}
				onClose={this.hide.bind(this)}
				onClick={this.hide.bind(this)}
			/>
		)
	}
}